import { create } from 'zustand'

interface IsBuyingState {
  isBuying: boolean;
  setIsBuying: (buy: boolean) => void;
}

const useIsBuying = create<IsBuyingState>((set) => ({
  isBuying: false,
  setIsBuying: (buy) => set({ isBuying: buy }),
}));

export default useIsBuying
